import type IUsersRepository from '@/core/domain/users/IUsersRepository.ts'
import type { LocalUser, UserView } from '@/core/domain/users/LocalUser.ts'

export default class BlockUserUseCase {
  private readonly userRepository: IUsersRepository

  constructor(userRepository: IUsersRepository) {
    this.userRepository = userRepository
  }

  async execute(identifier: string): Promise<LocalUser & UserView> {
    return this.userRepository.block(identifier)
  }
}